export const accountSummaryActionTypes = {
  FETCH_ACCOUNT_SUMMARY_START: 'FETCH_ACCOUNT_SUMMARY_START',
  FETCH_ACCOUNT_SUMMARY_SUCCESS: 'FETCH_ACCOUNT_SUMMARY_SUCCESS',
  FETCH_ACCOUNT_SUMMARY_FAILED: 'FETCH_ACCOUNT_SUMMARY_FAILED',
};
